import Api from "~/service/Api";

class ConstantRepository {
  fetch(query) {
    return Api.get("/constants", query);
  }
}

export default ConstantRepository;
